var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ConfigProvider } from '@arco-design/web-react';
import { useContext } from 'react';
var defaultCopy = {
    dismiss: 'Dismiss',
    showMore: 'Show more',
    showLess: 'Show less',
};
export var useI18nCopy = function () {
    var _a, _b;
    var locale = useContext(ConfigProvider.ConfigContext).locale;
    var tAlert = (locale === null || locale === void 0 ? void 0 : locale.Alert) || ((_a = locale === null || locale === void 0 ? void 0 : locale.M4B) === null || _a === void 0 ? void 0 : _a.Alert) || defaultCopy;
    var tNotiCard = (locale === null || locale === void 0 ? void 0 : locale.NotificationCard) ||
        ((_b = locale === null || locale === void 0 ? void 0 : locale.M4B) === null || _b === void 0 ? void 0 : _b.NotificationCard) ||
        defaultCopy;
    return __assign(__assign({}, tAlert), tNotiCard);
};
